import React from "react";

import { BaseProps } from "src/types";
import { useMarketsBody } from "./hooks";

export const Body = (props: BaseProps) => {
  const { getBodyProps } = useMarketsBody();
  return <div {...getBodyProps()}>{props.children}</div>;
};
